import { AppRoutes } from '@/constants';
import { navigate } from '@/providers';
import { mergeClasses } from '@/utils';

import { Send01Icon, XCloseIcon } from '@/assets/icons';
import { AuthGlassContainer, Button, SvgIcon } from '@/components/common';

interface IResetLinkStatus {
  isSuccess?: boolean;
}

export const ResetLinkStatus = ({ isSuccess = false }: IResetLinkStatus) => {
  return (
    <AuthGlassContainer className="w-[400px] flex flex-col items-center justify-center">
      <div
        className={mergeClasses(
          'size-[50px] border rounded-lg flex flex-row items-center justify-center',
          isSuccess ? 'bg-green-darkest border-green-base' : 'bg-red-darkest border-red-base',
        )}
      >
        <SvgIcon
          component={isSuccess ? Send01Icon : XCloseIcon}
          className="size-6 text-neutral-0"
        />
      </div>
      <span className="text-neutral-0 text-body-base font-semibold text-center mt-6 mb-2">
        {isSuccess ? 'Reset Link Sent!' : 'Reset Link Sent Failed!'}
      </span>
      <span className="font-medium text-body-sm text-opacity-light-70 text-center">
        {isSuccess ? (
          'We’ve sent password reset instructions to your email address.'
        ) : (
          <>
            Unable to send the password reset link. <br /> Please try again.
          </>
        )}
      </span>
      {!isSuccess && (
        <Button
          size="lg"
          buttonColor="neutral"
          buttonStyle="textlink"
          className="!text-neutral-5 mt-6"
          onClick={() => navigate(AppRoutes.LOGIN)}
        >
          Back to Login
        </Button>
      )}
    </AuthGlassContainer>
  );
};
